export default {"src":"/_next/static/media/GigsIcon.165d44ea.svg","height":15,"width":17};